import { Box, Typography } from '@mui/material';
import { StyledLeftSide } from '../../pages/SignIn/SignIn.styles';
import imageSilobolsa from '../../Images/silobolsa.svg'
import imageA3Neg from '../../Images/A3_mercado_neg.svg'
import imageOrigino from '../../Images/origino_qr.png'

const BaseA3 = () => {
  return (
    <StyledLeftSide
      style={{
        backgroundImage: `url(${imageSilobolsa})`,
        backgroundPosition: 'top',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        height: '100vh',
      }}
      item
      xs={6}
    >
      <Box
        style={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '2rem 0',
        }}
      >
        <Box
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant="h2"
            style={{
              fontWeight: 'bold',
              color: 'white',
              textAlign: 'center',
            }}
          >
            Warrant Plus
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            width: '100%',
            maxWidth: '600px',
            margin: '0 auto',
            paddingBottom: '1rem',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
            }}
          >
            <img
              style={{
                height: '40px',
                maxWidth: '100px',
                objectFit: 'contain',
              }}
              src={imageOrigino}
              alt="Origino"
            />
            <Typography
              variant="h4"
              sx={{
                color: 'white',
                whiteSpace: 'nowrap',
                fontWeight: 'bold'
              }}
            >
              Origino
            </Typography>
          </Box>

          <img
            style={{
              height: '60px',
              maxWidth: '150px',
              objectFit: 'contain',
            }}
            src={imageA3Neg}
            alt="Origino"
          />
        </Box>
      </Box>
    </StyledLeftSide>
  )
}

export default BaseA3;